import { STEPS } from '../../utils/routes.util';

export default BaseRouterConfig;

// @ngInject
function BaseRouterConfig($stateProvider) {
  $stateProvider.state(STEPS.LTE_INTERFACE_1, {
    url: '/lte-interface-1',
    template: '<dmattnt-lte-interface-1></dmattnt-lte-interface-1>',
    data: {label: 'Station LTE détectée'}
  }).state(STEPS.LTE_INTERFACE_2, {
    url: '/lte-interface-2',
    template: '<dmattnt-lte-interface-2></dmattnt-lte-interface-2>',
    data: {label: 'À bientôt'}
  });
}



// WEBPACK FOOTER //
// ./src/modules/lte/routes.js